import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_CONTENT_LINK_EVIDENCES,
  INCIDENT_DETAILS_SET_CONTENT_LINK_EVIDENCE,
} from '../../../../actions/actionTypes';

export const contentLinkEvidencesAdditionalActionsReducer = (state, action) => {
  switch (action.type) {
    case INCIDENT_DETAILS_SET_CONTENT_LINK_EVIDENCE: {
      const newData = [...state.data];
      const currentEvidenceIndex = newData.findIndex(
        ({ evidenceId }) => evidenceId === action.payload.evidence.evidenceId
      );
      if (currentEvidenceIndex >= 0) {
        newData[currentEvidenceIndex] = action.payload.evidence;
      } else {
        newData.push(action.payload.evidence);
      }
      return {
        ...state,
        data: newData,
      };
    }
    default:
      return state;
  }
};

const contentLinkEvidences = fetchReducerGenerator(
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_CONTENT_LINK_EVIDENCES,
  contentLinkEvidencesAdditionalActionsReducer
);

export default contentLinkEvidences;
